import { RxDatabase } from 'rxdb';

import { BorerDatabaseCollections } from '@/models/BorerDatabaseCollections';

import { rxdb16DatabaseName } from '../dbInitializer';
import { Crumbs } from './bakery/Crumbs';
import { BorerDatabaseCollectionsV2 } from './BorerDatabaseCollectionsV2';

export type Database = RxDatabase<BorerDatabaseCollectionsV2>;

export function crumble(database: Database): Crumbs {
  const { startupErrors, closed, collections } = database;
  return {
    startupErrors: startupErrors.map(e => e.message).join(', '),
    closed,
    collections: Object.keys(collections).length,
  };
}

export function isDatabase(value: unknown): value is Database {
  // `Database` is an `RxDatabase`, which does NOT pass `radash.isObject`.
  // `isObject` checks for `value.constructor === Object`,
  // but `RxDatabase.constructor === RxDatabase`.
  if (!value) return false;
  if (typeof value !== 'object') return false;
  const possible = value as Partial<Database>;
  // This is not a great determination of whether `value` is a `Database` or not,
  // but it should work.
  if (possible.name !== rxdb16DatabaseName) return false;
  return true;
}

export function toLegacyDB(database: Database): RxDatabase<BorerDatabaseCollections> {
  // This cast is safe because BorerDatabaseCollectionsV2 is a superset of BorerDatabaseCollections.
  // TODO: remove this once BorerDatabaseCollectionsV2 is merged into BorerDatabaseCollections https://nutrien.atlassian.net/browse/MDP-8188
  const db = database as unknown as RxDatabase<BorerDatabaseCollections>;
  return db;
}

export function toUpgradedDatabase(db: RxDatabase<BorerDatabaseCollections>): Database {
  // The difference between `RxDatabase<BorerDatabaseCollections>` and `Database`
  // is that the latter uses `BorerDatabaseCollectionsV2`.
  // The difference between the two database collections is that
  // the latter adds two additional collections
  // that are created by the V1 `dbInitializer` but not recorded in `BorerDatabaseCollections`
  // (most likely due to programming oversights).
  // Because the collections are indeed created,
  // it means that the V1 and V2 databases are actually compatible with each other,
  // and we can safely cast from one to the other.
  return db as unknown as Database;
}
